export class Medicine {

    Name: string;
	Reason: string;
    Dose: string;
	Strength: string;
	StartDate: Date;

    constructor(init?: Partial<Medicine>) {
        Object.assign(this, init);
    };
}



// WEBPACK FOOTER //
// ./src/app/shared/medicine.ts